// extracted by mini-css-extract-plugin
export var puzzleTileContainer = "PuzzleCell-module--puzzleTileContainer--87404";